export const GETTERS_LIST_CONSENT = "GETTERS_LIST_CONSENT";

export const ACTION_GET_LIST_CONSENT = "ACTION_GET_LIST_CONSENT";
export const ACTION_UPDATE_CONSENT = "ACTION_UPDATE_CONSENT";
export const ACTION_ADD_CONSENT = "ACTION_ADD_CONSENT";
export const ACTION_DELETE_CONSENT = "ACTION_DELETE_CONSENT";

export const MUTATION_SET_LIST_CONSENT = "MUTATION_SET_LIST_CONSENT";



// WEBPACK FOOTER //
// ./src/store/modules/consent/constants.js